import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { putAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const updateLandedCostAntiDumpingHistory = async (payload = []) => {
  const tokenInfo = await getJWTToken();
  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostAntiDumpingHistoryUpdate}`;
  const body = typeof payload === "string" ? payload : JSON.stringify(payload);
  const response = await putAPI(apiUrl, tokenInfo, body);

  if (!response) {
    AlertManager.error("Unable to update anti dumping history.");
    return null;
  }

  if (response.ok) {
    AlertManager.success("Anti dumping history updated successfully.", { contactSupport: false });
    return response;
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to update anti dumping history.");
  return null;
};

export default updateLandedCostAntiDumpingHistory;
